<template>
  <div>
    <the-nav-bar :title="$t('mine.faq')" />
    <div class="field-wrapper">
      <div class="field" v-for="(list, i) in routerLinkList" :key="i">
        <div
          class="field-item row-justify-center"
          v-for="(item, j) in list"
          :key="`${i}-${j}`"
          @click="linkTo(item)"
        >
          <svg class="field-item-icon">
            <use xlink:href="#icon-global-dot" />
          </svg>
          <div class="field-item-text" v-html="item.text"></div>

          <md-icon name="arrow-right" color="#e8e8f2"></md-icon>
        </div>
      </div>
    </div>

    <md-popup v-model="isShowPopup" position="bottom">
      <md-popup-title-bar
        only-close
        large-radius
        class="title-bar"
        :title="popupTitle"
        @confirm="hidePopup"
        @cancel="hidePopup"
      />
      <md-scroll-view :scrolling-x="false" auto-reflow class="scroll-view">
        <div
          class="scroll-item row-center"
          v-html="this.detail"
        >
          <!-- {{this.detail}} -->
        </div>
      </md-scroll-view>
    </md-popup>

  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { mapState } from 'vuex';
import { Icon, Popup, PopupTitleBar, ScrollView } from 'mand-mobile';
export default {
  components: {
    TheNavBar,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [ScrollView.name]: ScrollView,
  },
  data() {
    return {
      isShowPopup: false,
      popupTitle: '',
      detail:'',
    };
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
      userInfo: state => state.userInfo,
      navLang: state => state.navLang,
      routerLinkList() {
        return [
          [
            {
              text: this.$t('global.faqs[0].q'),
              detail: this.$t('global.faqs[0].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[1].q'),
              detail: this.$t('global.faqs[1].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[2].q'),
              detail: this.$t('global.faqs[2].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[3].q'),
              detail: this.$t('global.faqs[3].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[4].q'),
              detail: this.$t('global.faqs[4].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[5].q'),
              detail: this.$t('global.faqs[5].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[6].q'),
              detail: this.$t('global.faqs[6].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[7].q'),
              detail: this.$t('global.faqs[7].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[8].q'),
              detail: this.$t('global.faqs[8].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[9].q'),
              detail: this.$t('global.faqs[9].a'),
              handler: this.showPopup,
            }, 
            {
              text: this.$t('global.faqs[10].q'),
              detail: this.$t('global.faqs[10].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[11].q'),
              detail: this.$t('global.faqs[11].a'),
              handler: this.showPopup,
            },  
            {
              text: this.$t('global.faqs[12].q'),
              detail: this.$t('global.faqs[12].a'),
              handler: this.showPopup,
            },  
            {
              text: this.$t('global.faqs[13].q'),
              detail: this.$t('global.faqs[13].a'),
              handler: this.showPopup,
            },              
          ],
          [
            {
              text: this.$t('global.faqsMore'),
              hrefObj: {
                'zh-cn': 'https://help.tigaex.com/zh',
                en: 'https://help.tigaex.com/en',
              },
            },
          ],
        ];
      },
    }),
  },
  created() {

  },
  methods: {
    showPopup() {
      this.isShowPopup = true;
    },
    hidePopup() {
      this.isShowPopup = false;
    },
    linkTo(item) {
      if (typeof item.handler === 'function') {
        this.popupTitle = item.text;
        this.detail = item.detail;
        item.handler.call(item);
      }
      if (item.hrefObj) {
        return window.open(
          item.hrefObj[this.navLang],
          '_blank',
          'noopeener',
        );
      }
    },
  },
};
</script>

<style lang="stylus" scoped>

.field-wrapper {
  color: #23222e;
  padding-top: 3vw;
  border-top: 2.13vw solid #F8FBFC;

  .field + .field {
    border-top: 2.13vw solid #F8FBFC;
  }

  .field-item {
    flex-row-justify();
    height: 16.18vw;
    padding: 0 4vw;

    .field-item-icon {
      icon-size(6.4vw);
      padding-bottom: 2vw
    }

    .field-item-text {
      flex: 1;
      font-size: 3.73vw;
      border-bottom: 1px solid #e8e8f2
      padding-bottom: 1.18vw
    }

    .field-item-tag {
      icon-size(6.4vw);
      margin-right: 4.8vw;
    }
  }
3
}
.arrow-right
  fill: #e8e8f2

.title-bar {
border-bottom: 0.27vw solid #eaf1f3;
}

.scroll-view {
  background: #fff;
  padding-bottom: 10vw;
  height: auto;
  min-height: 60vw;
  max-height: 80vw;
  overflow-y: auto;
}

.scroll-item {
  display block;
  padding: 3.8vw 5.8vw 3.8vw 5.8vw;
  font-size: 4.27vw;
  height: 12.8vw;
  padding-bottom: 10vw;

  &.active {
    color: color-primary;
  }
}
</style>